import React, { createContext, useState } from 'react';
import { cameras, IMAGE_QUALITY, MAX_IMAGE_SIZE } from '../utils/constants';

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  
  const initialCameraState = cameras.reduce((acc, cam) => {
    acc[cam.id] = true;
    return acc;
  }, {});
  
  const [selectedCameras, setSelectedCameras] = useState(initialCameraState);
  const [selectedImageSize, setSelectedImageSize] = useState(MAX_IMAGE_SIZE);
  const [selectedQuality, setSelectedQuality] = useState(IMAGE_QUALITY);

  const value = {
    cameras,
    selectedCameras,
    setSelectedCameras,
    selectedImageSize,
    setSelectedImageSize,
    selectedQuality,
    setSelectedQuality,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
